import React, { useState } from 'react';
import { Routes, Route, NavLink, Navigate } from 'react-router-dom';
import Alerts from './Alerts';
import QR from './QR';
import Stats from './Stats';
import Subscription from './Subscription';
import Account from './Account';
import BillingHistory from './BillingHistory';
import UsageAnalytics from './UsageAnalytics';
import ReplyGenerator from './ReplyGenerator';
import ReviewFeed from './ReviewFeed';
import PublicProfileForm from './PublicProfileForm'; // <-- NEW

import './Dashboard.scss';

const linkClass = ({ isActive }: { isActive: boolean }) =>
  isActive ? 'sidebarLink active' : 'sidebarLink';

const Dashboard: React.FC = () => {
  const [open, setOpen] = useState(false);

  return (
    <div className="dashboardContainer">
      <div
        className={`sidebarBackdrop ${open ? 'show' : ''}`}
        onClick={() => setOpen(false)}
        aria-hidden={!open}
      />

      <aside className={`sidebar ${open ? 'open' : ''}`} aria-hidden={!open}>
        <button
          className="sideClose"
          aria-label="Fermer le menu"
          onClick={() => setOpen(false)}
        >
          ✕
        </button>

        <nav className="sidebarNav" onClick={() => setOpen(false)}>
          <NavLink to="/dashboard/reviews" className={linkClass}>Avis Clients</NavLink>
          <NavLink to="/dashboard/reply" className={linkClass}>Générateur de Réponses</NavLink>
          <NavLink to="/dashboard/alerts" className={linkClass}>Alertes</NavLink>
          <NavLink to="/dashboard/qr" className={linkClass}>QR Codes</NavLink>
          <NavLink to="/dashboard/stats" className={linkClass}>Statistiques</NavLink>
          <NavLink to="/dashboard/analytics" className={linkClass}>Analytics</NavLink>
          <NavLink to="/dashboard/public-profile" className={linkClass}>Profil public</NavLink> {/* NEW */}
          <NavLink to="/dashboard/account" className={linkClass}>Compte</NavLink>
          <NavLink to="/dashboard/subscription" className={linkClass}>Abonnement</NavLink>
          <NavLink to="/dashboard/billing" className={linkClass}>Facturation</NavLink>
        </nav>
      </aside>

      <div className="dashboardContent">
        <div className="dashTopBar">
          <button
            className="dashBurger"
            aria-label="Ouvrir le menu"
            aria-expanded={open}
            onClick={() => setOpen(true)}
          >
            ☰
          </button>
          <h1 className="dashTitle">Tableau de bord</h1>
        </div>

        <Routes>
          <Route path="/reviews" element={<ReviewFeed />} />
          <Route path="/reply" element={<ReplyGenerator />} />
          <Route path="/alerts" element={<Alerts />} />
          <Route path="/qr" element={<QR />} />
          <Route path="/stats" element={<Stats />} />
          <Route path="/analytics" element={<UsageAnalytics />} />
          <Route path="/billing" element={<BillingHistory />} />
          <Route path="/account" element={<Account />} />

          {/* NEW: Public profile editor (with and without :id) */}
          <Route path="/public-profile" element={<PublicProfileForm />} />
          <Route path="/public-profile/:id" element={<PublicProfileForm />} />

          <Route path="/subscription" element={<Subscription />} />
          <Route path="*" element={<Navigate to="/dashboard/reviews" replace />} />
        </Routes>
      </div>
    </div>
  );
};

export default Dashboard;
